import { faTasks } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { singleGoalPageRoute } from '../../common/linkRoutes';
import { GoalI } from '../../interfaces/GoalInterface';
import { useStore } from '../../store/store';
import './goals.css';
export interface GoalProps {
  data?: GoalI | null;
  task?: React.ReactNode;
  redirectOnClick?: string;
}

const Goal = (props: GoalProps) => {
  const { setGoal, setRedirect } = useStore();

  const { data } = props;

  return (
    <div className={`goal-component ${data?.goalStatus.toLocaleLowerCase()}`}>
      <div
        className={`clickable`}
        onClick={() => {
          setGoal(props.data || null);
          setRedirect(props.redirectOnClick || singleGoalPageRoute);
        }}
      >
        <div style={{ textAlign: 'left', padding: '0.5rem' }}>
          <h2 style={{ marginBottom: '-0.5rem' }}>{data?.title}</h2>
          <div style={{ opacity: '0.5' }}>
            <p>
              <em>{data?.des}</em>
            </p>
            {data && (
              <div>
                <FontAwesomeIcon
                  icon={faTasks}
                  style={{
                    marginRight: '.5rem',
                  }}
                />
                {data.details.pages ? 'Pages' : 'Chapters'}
                {data.details.pages || data.details.chapters}
              </div>
            )}
          </div>
        </div>
      </div>
      <div style={{ marginTop: '1rem' }}>{props.task && props.task}</div>
    </div>
  );
};

export default Goal;
